import { render, staticRenderFns } from "./SkillsWithGroups.vue?vue&type=template&id=61fa3cdc&scoped=true"
import script from "./SkillsWithGroups.vue?vue&type=script&lang=ts"
export * from "./SkillsWithGroups.vue?vue&type=script&lang=ts"
import style0 from "./SkillsWithGroups.vue?vue&type=style&index=0&id=61fa3cdc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fa3cdc",
  null
  
)

export default component.exports